// @flow strict

import LoadingPage, {Loading} from './loading.jsx';


export default LoadingPage;
export {Loading};
